import React from 'react';
import Heading from './Heading';
import Text from './Text';
import './SectionHeader.css';

function SectionHeader({
  title,
  subtitle,
  actions,
  className = '',
  ...rest
}) {
  const classes = ['ui-section-header', className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      <div className="ui-section-header__text">
        {title ? <Heading level="h2" className="ui-section-header__title">{title}</Heading> : null}
        {subtitle ? <Text variant="muted" as="p" className="ui-section-header__subtitle">{subtitle}</Text> : null}
      </div>
      {actions ? <div className="ui-section-header__actions">{actions}</div> : null}
    </div>
  );
}

export default SectionHeader;
